import {
  Organisation,
  OrganisationPage,
} from "../AppDataProvider/AppDataProvider";
import {
  bookingQuestions,
  serviceLimitedBookingQuestion,
} from "./bookingQuestions";

import { ServiceNotBookableAction } from "../GeneratedGraphQL";
import { crmFields } from "./crmFields";
import { createPageInfo } from "./pageInfo";

export const defaultOrganisationId = "111222333444555666777666";

const sharedSettings = {
  allowBookingNotes: false,
  allowResourceGroupSelection: true,
  allowResourceImageDisplay: true,
  allowResourceSelection: true,
  allowSelectAnyResource: true,
  areConfirmationEmailsEnabled: true,
  areInvoiceEmailsEnabled: true,
  bookingNoticePeriod: 0,
  businessPhone: "0131 222 9020",
  communicationFromEmail: "noreply@appointedd-bookings.com",
  currency: "GBP",
  enableMarketingOptIn: false,
  externalBookingQuestions: [],
  externalCrmFields: [],
  forceTimezone: "AUTO_DETECT",
  isPhoneNumberRequiredForBookings: true,
  marketingEnabled: false,
  micrositeColours: {
    primary: "#00204a",
    secondary: "#40bcff",
  },
  reservationExpiryMinutes: 7,
  resourceSelectionBeforeAvailability: true,
  serviceNotBookableAction: ServiceNotBookableAction.Call,
  showPricesOnBookingTools: true,
};

export const testOrganisation1: Organisation = {
  _id: defaultOrganisationId,
  ...sharedSettings,
  bookingConfirmationMessage: "Thank you for booking",
  defaultTimeZone: "Europe/London",
  externalBookingQuestions: bookingQuestions,
  externalCrmFields: crmFields,
  location: {
    address: "221A Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org A",
  proximityToSearchedLocation: 9.1,
  slug: "test_org_a",
  stripeIntegration: {
    accountId: "mockStripeAccountId",
  },
};

export const testOrganisationResourcesDisabled: Organisation = {
  _id: "111222333444555666777665",
  ...sharedSettings,
  allowResourceGroupSelection: false,
  allowResourceSelection: false,
  allowSelectAnyResource: false,
  bookingConfirmationMessage: "Thank you for booking",
  defaultTimeZone: "Europe/London",
  externalBookingQuestions: bookingQuestions,
  externalCrmFields: crmFields,
  location: {
    address: "221A Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org A",
  proximityToSearchedLocation: 9.1,
  slug: "test_org_a",
  stripeIntegration: {
    accountId: "mockStripeAccountId",
  },
};

export const squareIntegration = {
  locationId: "mockSquareLocationId",
};

export const testOrganisationSquare: Organisation = {
  _id: "111222333444555666777661",
  ...sharedSettings,
  currency: "USD",
  defaultTimeZone: "Europe/London",
  location: {
    address: "666 Sesame Street",
    latitude: "40.757206",
    longitude: "-73.924408",
  },
  name: "Test Org with Square Payment",
  proximityToSearchedLocation: 6,
  slug: "test_org_with_square_payment",
  squareIntegration,
};
export const testOrganisationAdyen: Organisation = {
  _id: defaultOrganisationId,
  ...sharedSettings,
  adyenIntegrationToken: {
    _id: "66e1741c104af567n365295f",
    adyenCheckoutBaseUrl: "https://checkout-test.adyen.com",
  },
  currency: "USD",
  defaultTimeZone: "Europe/London",
  location: {
    address: "666 Sesame Street",
    latitude: "40.757206",
    longitude: "-73.924408",
  },
  name: "Test Org with Adyen Payment",
  proximityToSearchedLocation: 6,
  slug: "test_org_with_adyen_payment",
};

export const testOrganisation2: Organisation = {
  _id: "111222333444555666777667",
  ...sharedSettings,
  currency: "USD",
  defaultTimeZone: "Europe/London",
  location: {
    address: "221B Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org B",
  privacyPolicyUrl: "http://appointedd.com",
  proximityToSearchedLocation: 100,
  slug: "test_org_b",
};

export const testOrganisation3: Organisation = {
  _id: "111222333444555666777668",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  externalBookingQuestions: [serviceLimitedBookingQuestion],
  isPhoneNumberRequiredForBookings: false,
  location: {
    address: "221C Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org C",
  proximityToSearchedLocation: 33,
  slug: "test_org_c",
};

export const testOrganisation4: Organisation = {
  _id: "111222333444555666777669",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221D Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org D",
  proximityToSearchedLocation: 19.7,
  slug: "test_org_d",
};

export const testOrganisation5: Organisation = {
  _id: "111222333444555666777670",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221E Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org E",
  proximityToSearchedLocation: 1000,
  slug: "test_org_e",
};

export const testOrganisation6: Organisation = {
  _id: "111222333444555666777671",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221F Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org F",
  proximityToSearchedLocation: 2016,
  slug: "test_org_f",
};

export const testOrganisation7: Organisation = {
  _id: "111222333444555666777672",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221G Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org G",
  proximityToSearchedLocation: 90,
  slug: "test_org_g",
};

export const testOrganisation8: Organisation = {
  _id: "111222333444555666777673",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221H Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org H",
  proximityToSearchedLocation: 90.1,
  slug: "test_org_h",
};

export const testOrganisation9: Organisation = {
  _id: "111222333444555666777674",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221I Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org I",
  proximityToSearchedLocation: 1875,
  slug: "test_org_i",
};

export const testOrganisation10: Organisation = {
  _id: "111222333444555666777675",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221J Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org J",
  proximityToSearchedLocation: 89,
  slug: "test_org_j",
};

export const organisationBookingNotesAllowed: Organisation = {
  _id: "111222333444555666777675",
  ...sharedSettings,
  allowBookingNotes: true,
  defaultTimeZone: "Europe/London",
  location: {
    address: "221K Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org K",
  slug: "test_org_k",
};

export const testOrganisation12: Organisation = {
  _id: "11122233344455566677767522",
  ...sharedSettings,
  defaultTimeZone: "America/Los_Angeles",
  location: {
    address: "221J Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org L",
  proximityToSearchedLocation: 89,
  slug: "test_org_L",
};

export const defaultOrganisation = testOrganisation1;
export const multipleOrganisations = [
  testOrganisation1,
  testOrganisation2,
  testOrganisation3,
  testOrganisation4,
  testOrganisation5,
  testOrganisation6,
  testOrganisation7,
  testOrganisation8,
  testOrganisation9,
  testOrganisation10,
];

export const organisationForcedTimezone: Organisation = {
  _id: "111222333444555666777932",
  ...sharedSettings,
  defaultTimeZone: "Europe/London",
  forceTimezone: "Europe/Paris",
  location: {
    address: "221P Eiffel Tower Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org Eiffel Tower",
  slug: "test_org_eiffel_tower",
};

export const noEmailsOrganisation: Organisation = {
  _id: "111222333444555666777933",
  ...sharedSettings,
  areConfirmationEmailsEnabled: false,
  areInvoiceEmailsEnabled: false,
  defaultTimeZone: "Europe/London",
  name: "No emails organisation",
  slug: "no_emails_organisation",
};
export const invoiceEmailsOnlyOrganisation: Organisation = {
  _id: "111222333444555666777933",
  ...sharedSettings,
  areConfirmationEmailsEnabled: false,
  areInvoiceEmailsEnabled: true,
  defaultTimeZone: "Europe/London",
  name: "No emails organisation",
  slug: "no_emails_organisation",
};

export const marketingEnabledOrganisation: Organisation = {
  _id: "111222333444555666777667",
  ...sharedSettings,
  currency: "USD",
  defaultTimeZone: "Europe/London",
  location: {
    address: "221B Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  marketingEnabled: true,
  name: "Marketing Corp",
  privacyPolicyUrl: "http://appointedd.com",
  proximityToSearchedLocation: 100,
  slug: "marketing-corp",
};

export const testOrganisationWithFeatureFlag: Organisation = {
  _id: defaultOrganisationId,
  ...sharedSettings,
  bookingConfirmationMessage: "Thank you for booking",
  bookingNoticePeriod: 24,
  defaultTimeZone: "Europe/London",
  enabledFeatureFlags: ["flag_one"],
  externalBookingQuestions: bookingQuestions,
  externalCrmFields: crmFields,
  location: {
    address: "221A Baker Street",
    latitude: "51.523772",
    longitude: "-0.158538",
  },
  name: "Test Org A",
  proximityToSearchedLocation: 9.1,
  slug: "test_org_a",
  stripeIntegration: {
    accountId: "mockStripeAccountId",
  },
};

export const organisationWithFeatureFlag = [testOrganisationWithFeatureFlag];

export const testOrganisationWithFeatureFlagPage: OrganisationPage = {
  edges: organisationWithFeatureFlag.map((org) => ({
    cursor: org._id,
    node: org,
  })),
  pageInfo: createPageInfo({ total: 1 }),
};

export const tenOrganisationsPage: OrganisationPage = {
  edges: multipleOrganisations.map((org) => ({ cursor: org._id, node: org })),
  pageInfo: createPageInfo({ total: 10 }),
};

export const twoOrganisations = [
  testOrganisation2,
  testOrganisationWithFeatureFlag,
];

export const twoOrganisationsPage: OrganisationPage = {
  edges: twoOrganisations.map((org) => ({ cursor: org._id, node: org })),
  pageInfo: createPageInfo({ total: 2 }),
};

export const twoOrganisationsDifferentTimezone = [
  testOrganisation12,
  testOrganisationWithFeatureFlag,
];
export const twoOrganisationsDifferentTimezonePage: OrganisationPage = {
  edges: twoOrganisationsDifferentTimezone.map((org) => ({
    cursor: org._id,
    node: org,
  })),
  pageInfo: createPageInfo({ total: 2 }),
};
